const tctsStore = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {}
};
export default tctsStore;
